import React from "react";
import { EventBySlugQuery } from "@src/@types/api.d";
import { parseEventDate } from "@src/utils/dateFormatter";

interface IFooter {
  slug: EventBySlugQuery | undefined;
}

const splitNames = (name?: string | null) => {
  if (!name) return ["", ""];

  const ampersandParts = name.split(/\s*&\s*/);
  if (ampersandParts.length >= 2) {
    return [ampersandParts[0], ampersandParts.slice(1).join(" & ")];
  }

  const andParts = name.split(/\s+and\s+/i);
  if (andParts.length >= 2) {
    return [andParts[0], andParts.slice(1).join(" and ")];
  }

  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return [words[0], words.slice(1).join(" ")];
  }

  return [name, ""];
};

const formatFooterDate = (date?: string | null) => {
  const parsed = parseEventDate(date);
  if (!parsed) return "";

  return parsed.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });
};

const Footer = ({ slug }: IFooter) => {
  const event = slug?.eventBySlug;
  const [firstName, secondName] = splitNames(event?.name);
  const eventDate = formatFooterDate(event?.date);
  const location = event?.event_parts?.find(
    (part) => part?.city || part?.state || part?.country
  );
  const locationText = [location?.city, location?.state, location?.country]
    .filter(Boolean)
    .join(", ");

  return (
    <footer className="relative border-t border-[#228B22]/15 bg-[#1C1820] px-6 py-20 text-center md:py-12">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(34,139,34,0.08)_0%,transparent_70%)]" />
      <div className="relative mx-auto flex max-w-3xl flex-col items-center">
        <p className="mb-3 font-jost text-[0.58rem] font-normal uppercase tracking-[0.5em] text-[#228B22]/70">
          {event?.hash_tag ? event.hash_tag : "With love"}
        </p>

        <div className="px-6 py-5 md:px-10">
          <h2 className="font-corGaramond text-[clamp(3rem,10vw,6rem)] font-light leading-none text-white">
            {firstName || event?.name || "With Love"}
            {secondName && (
              <>
                <span className="px-4 font-corGaramond font-light italic text-[#228B22]">
                  &
                </span>
                {secondName}
              </>
            )}
          </h2>
        </div>

        {(eventDate || locationText) && (
          <p className="mt-5 font-jost text-[0.58rem] font-normal uppercase tracking-[0.32em] text-white">
            {[eventDate, locationText].filter(Boolean).join(" · ")}
          </p>
        )}

        {/* <div className="mt-10 flex w-full max-w-[210px] items-center gap-6">
          <span className="h-px flex-1 bg-[#228B22]/45" />
          <span className="h-1.5 w-1.5 rotate-45 bg-[#228B22]" />
          <span className="h-px flex-1 bg-[#228B22]/45" />
        </div> */}

        {/* {event?.hash_tag && (
          <p className="mt-10 font-corGaramond text-xl font-light italic tracking-[0.08em] text-white/25">
            {event.hash_tag}
          </p>
        )} */}

        <p className="mt-8 font-jost text-[0.52rem] font-normal uppercase tracking-[0.34em] text-white">
          Made with{" "}
          <a
            href="https://www.inawo.com"
            target="_blank"
            rel="noopener noreferrer"
            className="border-b border-white pb-[1px] text-white transition hover:text-[#228B22] hover:border-[#228B22]"
          >
            Inawo
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
